exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".datepicker[data-v-ca1263dc] {\n  border-bottom: 1px solid #555;\n  width: 200px;\n  font-size: 1.1rem;\n}\n.datepicker-label[data-v-ca1263dc] {\n  font-size: 1rem;\n  color: #555;\n}\n.alert[data-v-ca1263dc] {\n  color: #e3342f;\n  font-size: 1rem;\n}", ""]);

// exports
